import React from 'react';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'destructive' | 'outline' | 'secondary';
  className?: string;
}

export const Badge = ({ children, variant = 'default', className = '' }: BadgeProps) => {
  const variantClasses = {
    default: 'bg-yellow-100 text-yellow-800 border-yellow-300',
    destructive: 'bg-red-100 text-red-800 border-red-300',
    outline: 'bg-transparent border-gray-300',
    secondary: 'bg-gray-100 text-gray-800 border-gray-300'
  };

  return (
    <div className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors ${variantClasses[variant]} ${className}`}>
      {children}
    </div>
  );
};
